// BulkUploadStudentsModal.js
import React, { useState } from "react";
import { X } from "lucide-react";
import Papa from "papaparse";
import { toast } from "react-toastify";

const BulkUploadStudentsModal = ({ isOpen, onClose, onSubmit }) => {
  const [csvFile, setCsvFile] = useState(null);

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleSubmit = () => {
    if (!csvFile) {
      toast.error("Please select a CSV file.");
      return;
    }

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const formattedData = results.data.map((student) => ({
          id: Date.now() + Math.random(),
          studentId: student.studentId,
          firstName: student.firstName,
          lastName: student.lastName,
          cohort: student.cohort,
          program: student.program,
          email: student.email,
          phone: student.phone,
          address: {
            street: student.street,
            city: student.city,
            state: student.state,
            zip: student.zip,
          },
          parentName: student.parentName,
          parentPhone: student.parentPhone,
          approved: true,
        }));

        onSubmit(formattedData);
        setCsvFile(null);
        onClose();
      },
      error: function (error) {
        console.error(error);
        toast.error("Error parsing CSV file.");
      },
    });
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <X size={20} />
        </button>
        <h2 id="modal-title" className="text-xl font-bold mb-4">
          Bulk Upload Students
        </h2>
        <div className="space-y-4">
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            className="w-full"
          />
          <p className="text-sm text-gray-500">
            <span className="mb-1 block">
              Please upload a CSV file with the following headers:
            </span>
            <code className="text-xs bg-gray-100 p-1 rounded break-all">
              studentId, firstName, lastName, cohort, program, email, phone,
              street, city, state, zip, parentName, parentPhone
            </code>
          </p>
          <p className="text-xs text-gray-400">
            Download our{" "}
            <a
              href="/sample_students.csv"
              download
              className="text-blue-500 underline hover:text-blue-600"
            >
              sample file
            </a>{" "}
            for reference.
          </p>
        </div>
        <div className="flex justify-end space-x-2 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadStudentsModal;
